import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";

import Context from '../../context/contextEmployees';

const Users = ({ match }) => (
  <Context>
    <Switch>
      <Route path={`${match.url}/empleados`} component={asyncComponent(() => import('./Employees'))} />
    </Switch>
  </Context>
);

export default Users;
